import { showToast } from '@/services/toastBus.js';
import Swal from "sweetalert2";

const TYPE_MAP = { success: 'success', error: 'error', warning: 'warn', info: 'info' };

export default {
  methods: {
    showSwal(options) {
      showToast(
        TYPE_MAP[options.type] || 'error',
        options.message,
        options.timer || 6000,
      );
    },
    showMessage(options) {
      Swal.fire({
        title: options.title || "Aviso",
        text: options.message || "",
        icon: options.type || null,
        width: options.width || 400,
        background: "#0e141f",
        color: "#e7edf5",
        confirmButtonText: options.confirmText || "Aceptar",
        showCloseButton: true,
        timer: options.timer || null,
        timerProgressBar: options.timer ? true : false,
      });
    },
    showConfirm(options) {
      return Swal.fire({
        title: options.title || "¿Estás seguro?",
        text: options.message || "",
        icon: options.type || "warning",
        width: options.width || 400,
        background: "#0e141f",
        color: "#e7edf5",
        confirmButtonText: options.confirmButtonText || options.confirmText || "Aceptar",
        cancelButtonText: options.cancelButtonText || "Cancelar",
        showCancelButton: true,
        showCloseButton: true,
      });
    }
  },
};
